var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHoverCardVectorLine = function SvgHoverCardVectorLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 509,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2c290 0 390.442 20.09 665 348.315 353.2 422.242 635-137.156 775-181.156",
    stroke: "#F0F1F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgHoverCardVectorLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1MDkiIHZpZXdCb3g9IjAgMCAxNDQwIDUwOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMkMyOTAgMS45OTk5MSAzOTAuNDQyIDIyLjA4OTcgNjY1IDM1MC4zMTVDMTAxOC4yIDc3Mi41NTcgMTMwMCAyMTMuMTU5IDE0NDAgMTY5LjE1OSIgc3Ryb2tlPSIjRjBGMUYyIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";